/* src/app/modules/notification/notification.component.scss */
.notif-top ::ng-deep span.p-dropdown-label {
  font-size: 0.75rem;
}
.notif-top ::ng-deep .p-dropdown-items {
  font-size: 0.75rem;
}
.notif-top ::ng-deep svg.p-dropdown-trigger-icon {
  height: 0.75rem;
}
.paginator-container {
  bottom: 0.6rem;
  left: 30%;
}
.paginator-container ::ng-deep span.p-dropdown-label {
  font-size: 0.75rem;
  padding: 0.5rem;
}
.paginator-container ::ng-deep .p-dropdown-items {
  font-size: 0.75rem;
  padding-block: 0.5rem;
}
.paginator-container ::ng-deep .p-dropdown-item {
  padding: 0.5rem;
}
.paginator-container ::ng-deep svg.p-dropdown-trigger-icon {
  height: 0.75rem;
}
.paginator-container ::ng-deep .p-paginator .p-paginator-current {
  height: 2rem;
  display: grid;
  place-items: center;
}
/*# sourceMappingURL=notification.component.css.map */
